import { jsx as _jsx } from "react/jsx-runtime";
import InteractionsSummaryCard from "../components/InteractionsSummaryCard";
import { generateAggregateTitle } from "./selectionUtils";
import { DEFAULT_CUSTOM_FILTERS } from "./interactionsCardsConstants";
export const renderInteractionCard = (props, handleCallOutcomesView, handleExecutiveSummary, handleResponseMetricsView, handlePdfExport) => {
    const { key, isTopCard = false, ...cardProps } = props;
    return (_jsx(InteractionsSummaryCard, { ...cardProps, onCallOutcomesClick: handleCallOutcomesView, onExecutiveSummaryClick: handleExecutiveSummary, onResponseMetricsClick: handleResponseMetricsView, ...(isTopCard && handlePdfExport && { onPdfExportClick: handlePdfExport }), ...(isTopCard && cardProps.onPresentationClick && { onPresentationClick: cardProps.onPresentationClick }) }, key));
};
export const createPresentationCards = (options) => {
    const { shouldShowAggregateCard, selectedAccounts, selectedUsers, allInteractions, allInteractionsByAccount, viewSettings, dateRange, entityLoadingStates, handleOpenInteractionsList, handleCallOutcomesView, handleExecutiveSummary, handleResponseMetricsView, } = options;
    const cards = [];
    if (shouldShowAggregateCard && (selectedAccounts.length > 0 || selectedUsers.length > 0)) {
        const aggregateTitle = generateAggregateTitle(selectedUsers, selectedAccounts);
        cards.push(renderInteractionCard({
            key: "aggregate-original",
            interactions: allInteractions,
            title: aggregateTitle,
            isAggregateCard: true,
            isLoading: Object.values(entityLoadingStates).some((loading) => loading),
            showViewSettingsButton: true,
            onViewSettingsClick: () => { },
            viewSettings: viewSettings,
            dateRange: dateRange,
            entityLoadingStates: entityLoadingStates,
            selectedAccountNames: selectedAccounts.map((account) => account.name),
            selectedUserNames: selectedUsers.map((user) => user.displayName || user.firstName + " " + user.lastName),
            customFilters: DEFAULT_CUSTOM_FILTERS,
            onTotalInteractionsClick: handleOpenInteractionsList,
        }, handleCallOutcomesView, handleExecutiveSummary, handleResponseMetricsView));
    }
    selectedAccounts.forEach((account) => {
        var _a;
        const accountInteractions = allInteractionsByAccount[account.id] || null;
        const accountTitle = accountInteractions && accountInteractions.length > 0 && ((_a = accountInteractions[0]) === null || _a === void 0 ? void 0 : _a.ToFilterObjectAccountName)
            ? accountInteractions[0].ToFilterObjectAccountName
            : account.name;
        cards.push(renderInteractionCard({
            key: `account-${account.id}`,
            interactions: accountInteractions,
            title: accountTitle,
            isAggregateCard: false,
            showViewSettingsButton: true,
            onViewSettingsClick: () => { },
            viewSettings: viewSettings,
            dateRange: dateRange,
            entityLoadingStates: entityLoadingStates,
            entityId: account.id,
            customFilters: DEFAULT_CUSTOM_FILTERS,
        }, handleCallOutcomesView, handleExecutiveSummary, handleResponseMetricsView));
    });
    selectedUsers.forEach((user) => {
        var _a;
        const userInteractions = allInteractionsByAccount[user.id] || null;
        const userTitle = userInteractions && userInteractions.length > 0 && ((_a = userInteractions[0]) === null || _a === void 0 ? void 0 : _a.ToObjectName)
            ? userInteractions[0].ToObjectName
            : user.displayName;
        cards.push(renderInteractionCard({
            key: `user-${user.id}`,
            interactions: userInteractions,
            title: userTitle,
            isAggregateCard: false,
            showViewSettingsButton: true,
            onViewSettingsClick: () => { },
            viewSettings: viewSettings,
            dateRange: dateRange,
            entityLoadingStates: entityLoadingStates,
            entityId: user.id,
            customFilters: DEFAULT_CUSTOM_FILTERS,
        }, handleCallOutcomesView, handleExecutiveSummary, handleResponseMetricsView));
    });
    return cards;
};
//# sourceMappingURL=interactionsCardsRenderUtils.js.map